module.exports = __webpack_public_path__ + "static/pr-op-picking@2x-56ec8948e50b20d8fbe8bd73df11e3bb.png";